export const arrayBatch = <T>(items: T[], batchLength: number) => {
  const batches: T[][] = items.reduce((result: T[][], item, index) => { 
    const chunkIndex = Math.floor(index / batchLength)
  
    if (!result[chunkIndex]) result[chunkIndex] = []

    result[chunkIndex].push(item)
    
    return result
  }, [])
  
  return batches
}

export const arrayCommon = <T>(a: T[], b: T[]) => {
  return (Array.isArray(a) ? a : []).filter(value => (Array.isArray(b) ? b : []).includes(value))
}

export const arrayMin = <T>(array: T[], length: number): (T | null)[] => {
  const emptyArray: (T | null)[] = new Array(length).fill(null)

  return emptyArray.map((value, i) => {
    return array[i] ?? null
  })
}

export const arrayEquals = <T>(a: T[], b: T[]) => {
  let found = 0

  a.forEach(item => {
    if (b.find(i => i === item)) found += 1
  })

  return a.length === b.length && found === a.length
}